import IvrsGateway from './ivrs_gateway';

/**
 * Threads Gateway
 */
export default class ThreadsGateway extends IvrsGateway {
  constructor(backend) {
    super(backend, 'v1/orgs/:orgId/consumer-self-service/ivrs/:id');
  }
}
